export default {
  // New id rather than a new `defaultMessage` on `article_meta_by`: the copy
  // changed, so the catalog should see a new string instead of serving stale

  words: { id: 'rm_article_meta_words', defaultMessage: 'By {author}' },
} as const
